import { render, staticRenderFns } from "./AreaAssignEditor.vue?vue&type=template&id=0bc6b3a5&scoped=true&"
import script from "./AreaAssignEditor.vue?vue&type=script&lang=ts&"
export * from "./AreaAssignEditor.vue?vue&type=script&lang=ts&"
import style0 from "./AreaAssignEditor.vue?vue&type=style&index=0&id=0bc6b3a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc6b3a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSimpleCheckbox,VSimpleTable,VTextField})
